import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

export const OidcIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 256 256"
    {...props}
  >
    <defs>
      <linearGradient id="linearGradient2555">
        <stop offset="0" stopColor="#FFF" stopOpacity="1"></stop>
        <stop offset="1" stopColor="#FFF" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="linearGradient2449"
        x1="-344.153"
        x2="-395.849"
        y1="274.711"
        y2="425.4"
        gradientTransform="matrix(-.59146 0 0 .59146 210.022 142.232)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#linearGradient2555"
      ></linearGradient>
    </defs>
    <g fillOpacity="1" transform="translate(-373.642 -318.344)">
      <rect
        width="236"
        height="236"
        x="-619.642"
        y="328.344"
        fill="#ebebee"
        fillRule="evenodd"
        stroke="#000"
        strokeDasharray="0.5,1"
        strokeDashoffset="0"
        strokeLinecap="square"
        strokeLinejoin="miter"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="0.5"
        rx="35.488"
        ry="35.488"
        transform="scale(-1 1)"
      ></rect>
      <path
        fill="url(#linearGradient2449)"
        fillRule="evenodd"
        stroke="none"
        strokeDasharray="0.87500000000000000, 1.75000000000000000"
        strokeDashoffset="0"
        strokeLinecap="square"
        strokeLinejoin="miter"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="0.875"
        d="M557.29 338.433H445.994c-29.46 0-53.178 23.912-53.178 53.615V500.64c.954 23.185 4.622 8.528 11.604-17.148 8.115-29.841 34.542-55.922 66.725-75.469 24.565-14.919 52.06-24.446 102.109-25.352 28.384-.514 25.878-36.84-15.962-44.238z"
        opacity="0.983"
      ></path>
      <path
        fill="#ff8e00"
        stroke="none"
        d="M488.082 538.406l26.93-19.415-1.252-154.065-25.678 20.04v153.44z"
      ></path>
      <path
        fill="#626262"
        stroke="none"
        d="M488.396 538.406c-100.73-16.014-103.6-103.711-.627-122.751l.313 18.162c-73.044 12.178-63.79 77.706 0 87.366l.314 17.223z"
      ></path>
      <path
        fill="#626262"
        stroke="none"
        d="M514.7 433.19c12.456.085 23.308 5.787 34.132 11.587l-15.97 11.899h51.042l.313-34.759-15.97 11.9c-16.162-8.163-31.017-17.96-53.548-18.162v17.535z"
      ></path>
    </g>
  </SvgIcon>
);
